import { lazy } from 'react';

const Login = lazy(() => import('./auth/components/LoginScreen'));
const Dashboard = lazy(() => import('./dashboard/components/DashboardScreen'));

export default [
    { path: '/login', component: Login },
    { path: '/', component: Dashboard }
];